import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddResearchLinePage } from './addResearchLine/addResearchLine';
import { ResearchLinePage } from './researchLine/researchLine';

@Component({
  selector: 'page-research-lines',
  templateUrl: 'researchLines.html',
  providers : [HttpClient]
})
export class ResearchLinesPage {

	researchLines;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addResearchLine:done',()=>{
        this.httpCallResearchLines('',1000);
      });
      this.events.subscribe('researchLine:delete',()=>{
        this.httpCallResearchLines('',1000);
      });
      this.events.subscribe('researchLine:update',()=>{
        this.httpCallResearchLines('',1000);
      });
      this.httpCallResearchLines('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallResearchLines(this.searchQuery,50);
      }else{
        this.httpCallResearchLines(this.searchQuery,1000);
      }
    }

    httpCallResearchLines(name,max){
      this.httpClient.get('/researchlines?name='+name+'&max='+max,(error,data)=>{
        this.researchLines = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddResearchLinePage);
    }

    onClickResearchLine(researchLine){
      this.navCtrl.push(ResearchLinePage,{id : researchLine.id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/researchLines/researchLines.ts